<template>
  <div class="hotel-settings">
    <div class="page-header"><h2><span class="breadcrumb-level">服务管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">宠境酒店</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">酒店设置</span></h2></div>
    <el-form :model="form" label-width="120px" v-loading="loading">
      <el-card class="info-card">
        <template #header><span>基础信息</span></template>
        <el-form-item label="酒店名称">
          <el-input v-model="form.company_name" placeholder="小程序端顶部显示" />
        </el-form-item>
        <el-form-item label="酒店图标">
          <div class="upload-wrap">
            <Upload v-model="form.hotel_icon" :max-count="1" tip="推荐尺寸 宽 64 × 高 86 px" />
          </div>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.company_phone" placeholder="用于一键拨号" />
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="form.company_address" placeholder="用于一键导航" />
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="纬度">
              <el-input-number v-model="form.hotel_latitude" :precision="7" :step="0.001" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经度">
              <el-input-number v-model="form.hotel_longitude" :precision="7" :step="0.001" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="tip">经纬度用于小程序端一键导航定位，与地址配合使用</div>
      </el-card>

      <el-card class="info-card" style="margin-top:20px;">
        <template #header><span>服务模式详情</span></template>
        <el-form-item label="服务模式简介">
          <el-input v-model="form.service_mode_brief" placeholder="请输入服务模式简介" />
        </el-form-item>
        <el-form-item label="服务模式详情">
          <RichTextEditor v-model="form.service_mode" />
          <div class="tip">不填则小程序端只展示简介</div>
        </el-form-item>
      </el-card>

      <div style="margin-top:20px;text-align:center;">
        <el-button type="primary" size="large" @click="handleSave" :loading="saving">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import * as contentApi from '../../api/contentManagement';
import Upload from '../../components/Upload.vue';
import RichTextEditor from '../../components/RichTextEditor.vue';

const loading = ref(false);
const saving = ref(false);
const form = reactive({
  company_name: '',
  hotel_icon: '',
  company_phone: '',
  company_address: '',
  hotel_latitude: null,
  hotel_longitude: null,
  service_mode: '',
  service_mode_brief: '',
});
const fetchData = async () => {
  loading.value = true;
  try {
    const res = await contentApi.getCompanyInfos();
    const data = res.data || {};
    if (data.company_name) form.company_name = data.company_name.value || '';
    if (data.hotel_icon) form.hotel_icon = data.hotel_icon.value || '';
    if (data.company_phone) form.company_phone = data.company_phone.value || '';
    if (data.company_address) form.company_address = data.company_address.value || '';
    if (data.hotel_latitude) form.hotel_latitude = parseFloat(data.hotel_latitude.value) || null;
    if (data.hotel_longitude) form.hotel_longitude = parseFloat(data.hotel_longitude.value) || null;
    if (data.service_mode) form.service_mode = data.service_mode.value || '';
    if (data.service_mode_brief) form.service_mode_brief = data.service_mode_brief.value || '';
  } catch { ElMessage.error('获取设置失败'); }
  finally { loading.value = false; }
};

const handleSave = async () => {
  saving.value = true;
  try {
    await contentApi.updateCompanyInfos({
      company_name: form.company_name,
      hotel_icon: form.hotel_icon,
      company_phone: form.company_phone,
      company_address: form.company_address,
      hotel_latitude: form.hotel_latitude,
      hotel_longitude: form.hotel_longitude,
      service_mode: form.service_mode,
      service_mode_brief: form.service_mode_brief,
    });
    ElMessage.success('保存成功');
  } catch { ElMessage.error('保存失败'); }
  finally { saving.value = false; }
};

onMounted(fetchData);
</script>

<style scoped>
.info-card { margin-bottom: 0; }
.tip { font-size: 12px; color: #999; text-align: center; margin-top: 8px; }
</style>
